import { Colors, DateFields, Services, getServiceNameKebabCase, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'
import { EReportTaskQueueStatus } from '@sigmasms/shared-types'

import { getLocaleDateString, getLocaleTimeString, icons } from '@/utils'

export const service = Services['report-manager/queue']
export const serviceNameViaPoint = getServiceNameViaPoint(service)
export const serviceNameKebabCase = getServiceNameKebabCase(service)

/**
 * Подстановки дат для пояснения к периоду по дням.
 * Последний день периода - день перед границей `lt`, которая в отчёт не входит.
 *
 * @param {{ gte: string, lt: string }} dateRange
 * @returns {{ from: string, to: string, lessThan: string }}
 */
export const getDateRangeByDaysReplacements = dateRange => {
  const lastDay = new Date(dateRange.lt)
  lastDay.setDate(lastDay.getDate() - 1)

  return {
    from: getLocaleDateString(dateRange.gte),
    to: getLocaleDateString(lastDay),
    lessThan: getLocaleDateString(dateRange.lt)
  }
}

export const reportManagerQueueStatuses = {
  [EReportTaskQueueStatus.pending]: {
    icon: icons.pending,
    color: Colors.info
  },
  [EReportTaskQueueStatus.dispatched]: {
    icon: icons.not_started,
    color: Colors.warning
  },
  [EReportTaskQueueStatus.running]: {
    icon: icons.play_circle_outline,
    color: Colors.info
  },
  [EReportTaskQueueStatus.completed]: {
    icon: icons.check_circle_outline,
    color: Colors.success
  },
  [EReportTaskQueueStatus.failed]: {
    icon: icons.error_outline,
    color: Colors.error
  },
  [EReportTaskQueueStatus.cancelled]: {
    icon: icons.do_not_disturb,
    color: Colors.grey
  }
}

export const fileInfo = {
  computed: {
    /**
     * Возвращает подпись к файлу с правильным полем даты.
     * При наличии блокировок показывается дата создания, иначе срок жизни ссылки.
     *
     * @returns {string}
     */
    fileLabel() {
      const createdAt = this.file?.createdAt
      const expiredAt = this.file?.expiredAt

      let dateField = DateFields.expiredAt
      let relevantDate = expiredAt
      if (this.hasLocks) {
        dateField = DateFields.createdAt
        relevantDate = createdAt
      }

      return [
        this.getTranslate(`file.labels.${dateField}`),
        getLocaleDateString(relevantDate),
        getLocaleTimeString(relevantDate)
      ].filter(Boolean).join(' ')
    },

    hasLocks() {
      return Array.isArray(this.file?.locks) && this.file.locks.length > 0
    }
  },

  watch: {
    value: {
      async handler(value) {
        await this.getFile(value?.fileId)
      },
      deep: true
    }
  },

  async mounted() {
    await this.getFile(this.value?.fileId)
  }
}
